'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var constants = require('../constants.js');
var styled = _interopDefault(require('styled-components'));
var _toConsumableArray = _interopDefault(require('@babel/runtime/helpers/toConsumableArray'));
var PropTypes = _interopDefault(require('prop-types'));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getTemplate = function getTemplate(config) {
  return function (props) {
    var propNames = config.propNames,
      propNameMap = config.propNameMap,
      breakpointWidths = config.breakpointWidths,
      cssTemplate = config.cssTemplate;
    return propNames.reduce(function (css, propName) {
      var breakpoint = propNameMap[propName];
      var breakpointWidth = breakpointWidths[breakpoint];
      var value = props[propName];
      if (typeof value === 'function') {
        value = value(props, {
          css: css,
          propName: propName,
          breakpoint: breakpoint,
          breakpointWidth: breakpointWidth
        }, config);
      }
      if (typeof value !== 'string') return css;
      var newCss = cssTemplate({
        breakpointWidth: breakpointWidth,
        value: value
      });
      if (typeof newCss !== 'string') return css;
      return "".concat(css, " ").concat(newCss);
    }, '');
  };
};
var getConfig = function getConfig(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    breakpointWidths = _ref.breakpointWidths;
  return Object.keys(breakpointWidths).reduce(function (_ref2, nextBreakpoint) {
    var propNameMap = _ref2.propNameMap,
      propNames = _ref2.propNames,
      propTypes = _ref2.propTypes;
    var newPropName = "".concat(prefix).concat(nextBreakpoint).concat(suffix);
    return {
      propNameMap: _objectSpread(_objectSpread({}, propNameMap), {}, _defineProperty({}, newPropName, nextBreakpoint)),
      propNames: [].concat(_toConsumableArray(propNames), [newPropName]),
      propTypes: _objectSpread(_objectSpread({}, propTypes), {}, _defineProperty({}, newPropName, PropTypes.oneOfType([PropTypes.string, PropTypes.func])))
    };
  }, {
    propNameMap: {},
    propNames: [],
    propTypes: {}
  });
};
var styledBreakpoint = (function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$prefix = _ref3.prefix,
    prefix = _ref3$prefix === void 0 ? '' : _ref3$prefix,
    _ref3$suffix = _ref3.suffix,
    suffix = _ref3$suffix === void 0 ? '-style' : _ref3$suffix,
    _ref3$breakpointWidth = _ref3.breakpointWidths,
    breakpointWidths = _ref3$breakpointWidth === void 0 ? constants.breakpointMinWidths : _ref3$breakpointWidth,
    _ref3$cssTemplate = _ref3.cssTemplate,
    cssTemplate = _ref3$cssTemplate === void 0 ? function (_ref4) {
      var breakpointWidth = _ref4.breakpointWidth,
        value = _ref4.value;
      return "@media (min-width: ".concat(breakpointWidth, ") { ").concat(value, " }");
    } : _ref3$cssTemplate,
    _ref3$defaultProps = _ref3.defaultProps,
    defaultProps = _ref3$defaultProps === void 0 ? {} : _ref3$defaultProps;
  return function (component) {
    var _getConfig = getConfig({
        prefix: prefix,
        suffix: suffix,
        breakpointWidths: breakpointWidths
      }),
      propNameMap = _getConfig.propNameMap,
      propNames = _getConfig.propNames,
      propTypes = _getConfig.propTypes;
    var template = getTemplate({
      propNameMap: propNameMap,
      propNames: propNames,
      propTypes: propTypes,
      breakpointWidths: breakpointWidths,
      cssTemplate: cssTemplate
    });
    var StyledBreakpoint = styled(component).withConfig({
      componentId: "u2kmlc-0"
    })(["", ""], template);
    StyledBreakpoint.propTypes = propTypes;
    StyledBreakpoint.defaultProps = defaultProps;
    return {
      propNameMap: propNameMap,
      propNames: propNames,
      propTypes: propTypes,
      template: template,
      component: StyledBreakpoint
    };
  };
});

exports.default = styledBreakpoint;
exports.getConfig = getConfig;
exports.getTemplate = getTemplate;
